module.exports = __webpack_public_path__ + "static/circle5-15b4953f7e048b7bc814de68909a25ae.png";